import { crudActions } from "./CrudActions"
import { kanbanActions } from "./KanbanActions"
import { comparadorActions } from "./ComparadorActions"
import apiClient from "@/services/ApiClient"

export default {
  ...crudActions("planificacions"),
  ...kanbanActions("planificacions"),
  ...comparadorActions("planificacions"),
  getPdf(id) {
    return apiClient.get(`/planificacions/${id}/pdf`)
  },
  getProfileActivitat(sessio_activitat_id) {
    return apiClient.get(`/sessions-activitats/${sessio_activitat_id}`)
  },
  getProfileSessioActivitat(sessio_activitat_id) {
    return apiClient.get(`/sessions-activitats/${sessio_activitat_id}`)
  },
  updateProfileSessioActivitat(sessio_activitat_id, data) {
    return apiClient.post(`/sessions-activitats/${sessio_activitat_id}`, data)
  },
}
